import {TourStep} from "@irati-web/tour"

import StepOne from "./steps/StepOne"
import StepTwo from "./steps/StepTwo"

export const HOMEPAGE_TOUR_PREFIX: string = "homepageTour"

const steps: TourStep[] = [
  {
    target: "[id=\"change-homepage-view\"]",
    Content: StepOne,
    placement: "auto",
    disableBeacon: true
  },
  {
    target: `[data-tour="${HOMEPAGE_TOUR_PREFIX}-step02"]`,
    Content: StepTwo,
    placement: "auto"
  }
]

export default steps
